import {
  SiReact, SiVuedotjs, SiAngular, SiNextdotjs, SiNodedotjs, SiExpress, SiPython, SiDjango,
  SiFlask, SiPhp, SiLaravel, SiDotnet, SiMysql, SiPostgresql, SiMongodb, SiSqlite, SiFirebase,
  SiDocker, SiGit, SiGithub, SiGitlab, SiJavascript, SiTypescript, SiHtml5, SiCss, SiTailwindcss,
  SiBootstrap, SiWordpress, SiShopify, SiFigma, SiFlutter, SiKotlin, SiSwift, SiAndroidstudio,
  SiXcode, SiGooglecloud, SiRedis, SiGraphql, SiWebpack, SiVite, SiJquery, SiSass,
  SiGoogle, SiGooglesearchconsole, SiGoogleanalytics, SiGoogleads,
  SiQuickbooks, SiXero, SiSage, SiZoho,
  SiFacebook, SiInstagram, SiTiktok, SiMailchimp, SiHubspot, SiMeta, SiHootsuite, SiBuffer, SiCanva,
  SiOpenai, SiGooglegemini, SiClaude, SiElevenlabs, SiHuggingface, SiReplicate, SiMistralai,
  SiOllama, SiLangchain, SiN8N, SiZapier, SiMake, SiWhatsapp, SiTelegram, SiNotion, SiPerplexity,
} from "react-icons/si";
import { FaAws } from "react-icons/fa6";

// Shared between the admin icon picker and the public Services display, keyed by a stable
// string (stored comma-separated on ServiceCard.icons) so the DB never stores component refs.
export const DEV_TOOL_ICONS = [
  { key: "SiReact", label: "React", Icon: SiReact },
  { key: "SiVuedotjs", label: "Vue.js", Icon: SiVuedotjs },
  { key: "SiAngular", label: "Angular", Icon: SiAngular },
  { key: "SiNextdotjs", label: "Next.js", Icon: SiNextdotjs },
  { key: "SiNodedotjs", label: "Node.js", Icon: SiNodedotjs },
  { key: "SiExpress", label: "Express.js", Icon: SiExpress },
  { key: "SiPython", label: "Python", Icon: SiPython },
  { key: "SiDjango", label: "Django", Icon: SiDjango },
  { key: "SiFlask", label: "Flask", Icon: SiFlask },
  { key: "SiPhp", label: "PHP", Icon: SiPhp },
  { key: "SiLaravel", label: "Laravel", Icon: SiLaravel },
  { key: "SiDotnet", label: ".NET", Icon: SiDotnet },
  { key: "SiMysql", label: "MySQL", Icon: SiMysql },
  { key: "SiPostgresql", label: "PostgreSQL", Icon: SiPostgresql },
  { key: "SiMongodb", label: "MongoDB", Icon: SiMongodb },
  { key: "SiSqlite", label: "SQLite", Icon: SiSqlite },
  { key: "SiFirebase", label: "Firebase", Icon: SiFirebase },
  { key: "SiDocker", label: "Docker", Icon: SiDocker },
  { key: "SiGit", label: "Git", Icon: SiGit },
  { key: "SiGithub", label: "GitHub", Icon: SiGithub },
  { key: "SiGitlab", label: "GitLab", Icon: SiGitlab },
  { key: "SiJavascript", label: "JavaScript", Icon: SiJavascript },
  { key: "SiTypescript", label: "TypeScript", Icon: SiTypescript },
  { key: "SiHtml5", label: "HTML5", Icon: SiHtml5 },
  { key: "SiCss", label: "CSS3", Icon: SiCss },
  { key: "SiTailwindcss", label: "Tailwind CSS", Icon: SiTailwindcss },
  { key: "SiBootstrap", label: "Bootstrap", Icon: SiBootstrap },
  { key: "SiWordpress", label: "WordPress", Icon: SiWordpress },
  { key: "SiShopify", label: "Shopify", Icon: SiShopify },
  { key: "SiFigma", label: "Figma", Icon: SiFigma },
  { key: "SiFlutter", label: "Flutter", Icon: SiFlutter },
  { key: "SiKotlin", label: "Kotlin", Icon: SiKotlin },
  { key: "SiSwift", label: "Swift", Icon: SiSwift },
  { key: "SiAndroidstudio", label: "Android Studio", Icon: SiAndroidstudio },
  { key: "SiXcode", label: "Xcode", Icon: SiXcode },
  { key: "FaAws", label: "AWS", Icon: FaAws },
  { key: "SiGooglecloud", label: "Google Cloud", Icon: SiGooglecloud },
  { key: "SiRedis", label: "Redis", Icon: SiRedis },
  { key: "SiGraphql", label: "GraphQL", Icon: SiGraphql },
  { key: "SiWebpack", label: "Webpack", Icon: SiWebpack },
  { key: "SiVite", label: "Vite", Icon: SiVite },
  { key: "SiJquery", label: "jQuery", Icon: SiJquery },
  { key: "SiSass", label: "Sass", Icon: SiSass },
  { key: "SiGoogle", label: "Google", Icon: SiGoogle },
  { key: "SiGooglesearchconsole", label: "Google Search Console", Icon: SiGooglesearchconsole },
  { key: "SiGoogleanalytics", label: "Google Analytics", Icon: SiGoogleanalytics },
  { key: "SiGoogleads", label: "Google Ads", Icon: SiGoogleads },
  { key: "SiQuickbooks", label: "QuickBooks", Icon: SiQuickbooks },
  { key: "SiXero", label: "Xero", Icon: SiXero },
  { key: "SiSage", label: "Sage", Icon: SiSage },
  { key: "SiZoho", label: "Zoho", Icon: SiZoho },
  { key: "SiFacebook", label: "Facebook", Icon: SiFacebook },
  { key: "SiInstagram", label: "Instagram", Icon: SiInstagram },
  { key: "SiTiktok", label: "TikTok", Icon: SiTiktok },
  { key: "SiMailchimp", label: "Mailchimp", Icon: SiMailchimp },
  { key: "SiHubspot", label: "HubSpot", Icon: SiHubspot },
  { key: "SiMeta", label: "Meta", Icon: SiMeta },
  { key: "SiHootsuite", label: "Hootsuite", Icon: SiHootsuite },
  { key: "SiBuffer", label: "Buffer", Icon: SiBuffer },
  { key: "SiCanva", label: "Canva", Icon: SiCanva },
  { key: "SiOpenai", label: "OpenAI", Icon: SiOpenai },
  { key: "SiGooglegemini", label: "Google Gemini", Icon: SiGooglegemini },
  { key: "SiClaude", label: "Claude", Icon: SiClaude },
  { key: "SiElevenlabs", label: "ElevenLabs", Icon: SiElevenlabs },
  { key: "SiHuggingface", label: "Hugging Face", Icon: SiHuggingface },
  { key: "SiReplicate", label: "Replicate", Icon: SiReplicate },
  { key: "SiMistralai", label: "Mistral AI", Icon: SiMistralai },
  { key: "SiOllama", label: "Ollama", Icon: SiOllama },
  { key: "SiLangchain", label: "LangChain", Icon: SiLangchain },
  { key: "SiN8N", label: "n8n", Icon: SiN8N },
  { key: "SiZapier", label: "Zapier", Icon: SiZapier },
  { key: "SiMake", label: "Make", Icon: SiMake },
  { key: "SiWhatsapp", label: "WhatsApp", Icon: SiWhatsapp },
  { key: "SiTelegram", label: "Telegram", Icon: SiTelegram },
  { key: "SiNotion", label: "Notion", Icon: SiNotion },
  { key: "SiPerplexity", label: "Perplexity", Icon: SiPerplexity },
];

export const DEV_TOOL_ICON_MAP = Object.fromEntries(DEV_TOOL_ICONS.map((i) => [i.key, i]));
